/* PDP only. Tap (kein Flickity-Drag) öffnet Focal PhotoSwipe (weiß, Punkte, Pfeile). */
(() => {
  if (window.__pdpGalleryZoom) return;
  window.__pdpGalleryZoom = true;

  const SLOP = 10;

  const ignore = (el) =>
    el.closest(
      "button, a, .product__thumbnail-list, .dots-nav, .product__media-prev-next, .video-wrapper, model-media, .pswp"
    );

  const openZoom = (mediaId) => {
    const root = document.querySelector("product-media");
    const zoom = root?.querySelector("product-image-zoom");
    if (!zoom) return;

    if (mediaId) {
      root.querySelectorAll(".product__media-item[data-media-id]").forEach((item) => {
        item.classList.toggle("is-selected", item.getAttribute("data-media-id") === String(mediaId));
      });
    }

    const selected = root.querySelector(".product__media-item.is-selected");
    if (selected && selected.getAttribute("data-media-type") !== "image") return;

    zoom.open = true;
  };

  let start = null;

  document.addEventListener(
    "pointerdown",
    (event) => {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (ignore(event.target)) return;

      const gallery = event.target.closest(".product__media-image-wrapper--pdp");
      const extra = event.target.closest('.product-extra-images__item[data-media-type="image"]');
      if (!gallery && !extra) return;

      start = { x: event.clientX, y: event.clientY, gallery, extra };
    },
    { passive: true }
  );

  document.addEventListener("pointerup", (event) => {
    if (!start) return;
    const { x, y, gallery, extra } = start;
    start = null;
    if (Math.hypot(event.clientX - x, event.clientY - y) > SLOP) return;

    if (gallery) {
      openZoom(gallery.closest(".product__media-item")?.getAttribute("data-media-id"));
      return;
    }

    if (extra) openZoom(extra.getAttribute("data-media-id"));
  });

  document.addEventListener("pointercancel", () => {
    start = null;
  });
})();
